import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserSalesLeadPersonUrl } from "../utils/constants/apiEndPoints";
import { HTTP_STATUS_SUCCESS } from "../utils/constants/appConstants";
import privateAxios from "../utils/axiosPrivate";

const initialState = {
  userSlaesLead: []
};
const userSalesLeadPersonSlice = createSlice({
  name: "userSalesLead",
  initialState,
  reducers: {
    setUserSlaesLead(state, action) {
      state.userSlaesLead = action.payload;
    }
  }
});

// Async thunk to get userSlaesLead data
export const getSalseLead = createAsyncThunk(
  "userSalesLead/getSalseLead",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getUserSalesLeadPersonUrl);
      if (
        response.status === 200 &&
        response.data.status === HTTP_STATUS_SUCCESS
      ) {
        dispatch(setUserSlaesLead(response.data.data));
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const { setUserSlaesLead } = userSalesLeadPersonSlice.actions;
export default userSalesLeadPersonSlice.reducer;
